import React from "react";
import ModalBase from "../../../../components/common/modal/ModalBase";
import { Button, Stack, Typography } from "@mui/material";
import Tabbase from "../../../../components/common/tab/Tabbase";
import InfoSection from "./info-section/InfoSection";

interface IFormBooking {
  open: boolean;
  onClose: () => void;
}

function FormBooking({ open, onClose }: IFormBooking) {
  return (
    <ModalBase
      open={open}
      handleClose={onClose}
      title="Cập nhật thông tin"
      width="800px"
      actions={[
        <Stack
          key={1}
          gap={1}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              backgroundColor: "primary.main",
              color: "common.white",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "primary.main",
                boxShadow: "none",
              },
            }}
          >
            Đặt vé
          </Button>
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              backgroundColor: "background.default",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "background.default",
                boxShadow: "none",
              },
            }}
          >
            Đóng
          </Button>
        </Stack>,
      ]}
    >
      <Stack gap={2} sx={{ maxHeight: "70vh", overflow: "auto" }}>
        <Stack direction="row" alignItems="center" sx={{ px: 2 }} gap={2}>
          <Typography>Đang chọn 1 ghế</Typography>
          <Typography
            sx={{ px: 2, py: 1, backgroundColor: "background.default" }}
          >
            A1
          </Typography>
        </Stack>
        <Tabbase
          tabs={[
            {
              label: "Thông tin chung",
              value: "1",
            },
            {
              label: "Lịch sử",
              value: "2",
            },
            {
              label: "Lịch sử mới",
              value: "3",
            },
          ]}
          panels={[
            { value: "1", content: <InfoSection /> },
            { value: "2", content: <InfoSection /> },
            { value: "3", content: <InfoSection /> },
          ]}
        />
      </Stack>
    </ModalBase>
  );
}

export default FormBooking;
